import { LOGLEVEL } from './constants';
import { LogEntry, LoggerTransport } from './interfaces';

export class ConsoleTransport implements LoggerTransport {
  private consoleLog: typeof console.log;
  private consoleTrace: typeof console.trace;
  private consoleDebug: typeof console.debug;
  private consoleWarn: typeof console.warn;
  private consoleError: typeof console.error;
  private consoleInfo: typeof console.info;

  constructor() {
    this.overrideConsoleLog();
  }

  overrideConsoleLog() {
    this.consoleLog = console.log;
    this.consoleTrace = console.trace;
    this.consoleDebug = console.debug;
    this.consoleWarn = console.warn;
    this.consoleError = console.error;
    this.consoleInfo = console.info;

    console.log = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.LOG, message: args[0], params: args.splice(1) ?? [] });
    };

    console.trace = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.TRACE, message: args[0], params: args.splice(1) ?? [] });
    };

    console.debug = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.DEBUG, message: args[0], params: args.splice(1) ?? [] });
    };

    console.warn = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.WARN, message: args[0], params: args.splice(1) ?? [] });
    };

    console.error = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.ERROR, message: args[0], params: args.splice(1) ?? [] });
    };

    console.info = (...args: any) => {
      if (this.filter(args[0])) {
        return;
      }

      this.log({ level: LOGLEVEL.INFO, message: args[0], params: args.splice(1) ?? [] });
    };
  }

  filter(message: any): boolean {
    if (!message) {
      return false;
    }

    if (message.match('.*webpack-dev-server.*')) {
      return true;
    }

    if (message.match('.*enableProdMode.*')) {
      return true;
    }

    if (message.match('.*Preloaded (en|es).*')) {
      return true;
    }

    return false;
  }

  // show the log message
  log(logEntry: LogEntry) {
    const message = logEntry.message;
    const params = logEntry.params;

    let level: string;

    if (logEntry.level.includes(LOGLEVEL.DEBUG)) {
      level = `[${LOGLEVEL.DEBUG}]`;
    } else {
      level = `[${logEntry.level}]`;
    }

    switch (logEntry.level) {
      case LOGLEVEL.DISABLE:
        break;

      case LOGLEVEL.LOG:
        this.consoleLog(message, ...params);
        break;

      case LOGLEVEL.TRACE:
        this.consoleTrace(level, message, ...params);
        break;

      case LOGLEVEL.DEBUG1:
      case LOGLEVEL.DEBUG2:
      case LOGLEVEL.DEBUG3:
        this.consoleDebug(level, message, ...params);
        break;

      case LOGLEVEL.WARN:
        this.consoleWarn(level, message, ...params);
        break;

      case LOGLEVEL.ERROR:
        this.consoleError(level, message, ...params);
        break;

      default:
      case LOGLEVEL.INFO:
        this.consoleInfo(level, message, ...params);
        break;
    }
  }
}
